/* eslint-disable no-console,no-undef, camelcase */
/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NoComments } from "../../SocialFeeds/styles";
import { withTranslation } from "react-i18next";
import {
  fetchOnDemandVideosByCatgoryId,
} from "../../../redux/actions";
import OnDemandCards from "./onDemandCards";
import {
  OndemandContainer,
  HeadingContainer,
  NewCardContainer,
  EventHeading,
} from "./style";
import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";
import Waiting from "../../Waiting";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ToolTipNew } from "../../AdminTeamCreation/styles";
import StyledDropDown from "./categoryDropdown";
//import { StyledSvgNew } from "../styles";
import { NewBackArrowIconForEvents } from "../../../utils/icons";

class OnDemandDetailsMain extends Component {
  constructor() {
    super();
    this.state = {
      pageNumber: 1,
      tab: 1,
      activeStatus: true,
      onHover: -1,
      eventCreate: false,
      showMenu: false,
      dropdown: 0,
      open: false,
      selectedItem: "",
      showBack: false,
    };
  }

  componentDidMount() {
    const {
      fetchOnDemandVideosByCatgoryId,
      history,
      ondemandCategory,
    } = this.props;
    const StringArray = history.location.pathname.split("/");
    fetchOnDemandVideosByCatgoryId(StringArray[StringArray.length - 1]);
    ondemandCategory &&
      ondemandCategory.map((item) => {
        if (item.id == StringArray[StringArray.length - 1]) {
          this.setState({
            selectedItem: item.name,
          });
        }
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.history.location !== this.props.history.location) {
      const { history, fetchOnDemandVideosByCatgoryId, ondemandCategory } =
        this.props;
      const StringArray = history.location.pathname.split("/");
      fetchOnDemandVideosByCatgoryId(StringArray[StringArray.length - 1]);
      ondemandCategory &&
        ondemandCategory.map((item) => {
          if (item.id == StringArray[StringArray.length - 1]) {
            this.setState({
              selectedItem: item.name,
            });
          }
        });
    }
  }

  selectCategoryAPI = (value) => {
    const { fetchOnDemandVideosByCatgoryId } = this.props;
    fetchOnDemandVideosByCatgoryId(value);
  };

  showArticle = (id) => {
    const { history, location } = this.props;
    const currentLocation = location.pathname;
    const stringArray = location.pathname.split("/");
    let url = stringArray[2] === "videos-library" ? "fitness" : "article";
    history.push(`${currentLocation}/${url}/${id}`);
  };

  onScroll = (e, events) => {
    const { pageNumber } = this.state;
    const { loadMoreEvents, totalCount } = this.props;
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (events.length < totalCount) {
      if (bottom) {
        this.setState(
          {
            pageNumber: pageNumber + 1,
          },
          () => {
            loadMoreEvents(this.state.pageNumber);
          }
        );
      }
    }
  };

  onEnterMouse = (id) => {
    this.setState({
      onHover: id,
    });
  };

  updateCategoryName = (value) => {
    this.setState({
      selectedItem: value,
    });
  };

  onLeaveMouse = () => {
    this.setState({
      onHover: -1,
    });
  };

  showPastEvents = (status) => {
    this.setState({ activeStatus: status ? 0 : 1 });
  };

  eventButtonStatusHover = (value) => {
    if (value === "event")
      this.setState({
        eventCreate: true,
      });
    else if (value === "menu") {
      this.setState({
        showMenu: true,
      });
    } else {
      this.setState({
        showBack: true,
      });
    }
  };

  eventButtonStatus = (value) => {
    if (value === "event")
      this.setState({
        eventCreate: false,
      });
    else if (value === "menu") {
      this.setState({
        showMenu: false,
      });
    } else {
      this.setState({
        showBack: false,
      });
    }
  };

  showDropDown = () => {
    this.setState({
      dropdown: !this.state.dropdown,
      open: true,
    });
  };

  hideDropDown = () => {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  };

  onSelect = (value) => {
    this.setState({
      selectedItem: value,
    });
  };

  renderHeading = () => {
    const { eventCreate, showMenu, dropdown, selectedItem } =
      this.state;
    const { role, t } = this.props;
    const popover = (value) => (
      <Popover
        id="popover-basic"
        style={{
          width: "auto",
          padding: "9px 14px",
          background: "#FFFFFF",
          border: "1px solid #005c87",
          boxShadow: "0px 13px 28px rgba(0, 0, 0, 0.3)",
          borderRadius: "6px",
        }}
      >
        <div
          style={{
            fontFamily: "Rubik",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#005c87",
            textAlign: "center",
          }}
        >
          {value}
        </div>
      </Popover>
    );

    return (
      <EventHeading style={{height:"56px"}}>
        <ToolTipNew
          margin={"auto 0px auto 15px"}
          height="40px"
          width="40px"
        >
          <OverlayTrigger placement="bottom" overlay={popover(this.props.t("Back"))}>
            <div
              className='toolTip'
              onClick={() => this.props.history.push(`/events`)}
              style={{ background: "none" }} 
            >
              <NewBackArrowIconForEvents/> 
            </div>
          </OverlayTrigger>
        </ToolTipNew>

        <div className="title">{`${t(selectedItem)}`}</div>
        {role === "ADMIN" && (
          <ToolTipNew
            margin={"auto 0px auto auto"}
            active={eventCreate}
            onMouseEnter={() => this.eventButtonStatusHover("event")}
            onMouseLeave={() => this.eventButtonStatus("event")}
          >
            <OverlayTrigger
              placement="bottom"
              overlay={popover(this.props.t("Create on-Demand Classes"))}
            >
              <div
                className='="toolTip'
                onClick={() =>
                  this.props.history.push(`/company/events/create-ondemand`)
                }
              >
                
              </div>
            </OverlayTrigger>
          </ToolTipNew>
        )}
        <ToolTipNew
          margin={role === "ADMIN" ? "auto 0px auto 0" : "auto 0px auto auto"}
          active={showMenu || dropdown != 0}
          onClick={() => this.showDropDown()}
          onMouseEnter={() => this.eventButtonStatusHover("menu")}
          onMouseLeave={() => this.eventButtonStatus("menu")}
        >
          {/* <OverlayTrigger placement="bottom" overlay={popover(this.props.t("Select Categories"))}>
            <div onClick={() => this.showDropDown()}>
              <StyledSvgNew
                width="24px"
                height="24px"
                active={showMenu || dropdown != 0}
              >
                <svg
                  width="24"
                  height="auto"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 0C0.895431 0 0 0.895433 0 2V8.8C0 9.90457 0.895433 10.8 2 10.8H10.8V2C10.8 0.895431 9.90457 0 8.8 0H2ZM2 13.2C0.895431 13.2 0 14.0954 0 15.2V22C0 23.1046 0.895433 24 2 24H8.8C9.90457 24 10.8 23.1046 10.8 22V13.2H2ZM13.2 2C13.2 0.895433 14.0954 0 15.2 0H22C23.1046 0 24 0.895431 24 2V8.8C24 9.90457 23.1046 10.8 22 10.8H13.2V2ZM22 13.2H13.2V22C13.2 23.1046 14.0954 24 15.2 24H22C23.1046 24 24 23.1046 24 22V15.2C24 14.0954 23.1046 13.2 22 13.2Z"
                    fill="#9C9C9C"
                  />
                </svg>
              </StyledSvgNew>
            </div>
          </OverlayTrigger> */}
        </ToolTipNew>
      </EventHeading>
    );
  };

  render() {
    const { history, t, link, ondemandByIdData } =
      this.props;
    const { activeStatus, onHover } = this.state;
    if (
      isUndefined(ondemandByIdData) ||
      isNull(ondemandByIdData)
    ) {
      return <Waiting />;
    }
    return (
      <div>
        {activeStatus ? (
          <OndemandContainer>
            <div>
              <HeadingContainer>{this.renderHeading()}</HeadingContainer>
              {this.state.dropdown != 0 ? (
                <StyledDropDown
                  title={t("Adventures Categories")}
                  MenuItems={this.props.ondemandCategory}
                  isAdventurePage={true}
                  history={history}
                  onSelect={this.selectCategoryAPI}
                  isOpen={true}
                  hideDropDown={this.hideDropDown}
                  updateCategoryName={this.updateCategoryName}
                />
              ) : (
                ""
              )}
              <NewCardContainer topMargin={"topMargin"}>
                {ondemandByIdData && ondemandByIdData.length === 0 ? (
                  <NoComments>
                    {t("No Ondemand Videos Available For This Category")}
                  </NoComments>
                ) : (
                  ondemandByIdData &&
                  ondemandByIdData.length > 0 &&
                  ondemandByIdData.map((video, index) => (
                    <OnDemandCards
                      video={video}
                      key={index}
                      history={history}
                      grid={0}
                      link={link}
                      onEnterMouse={this.onEnterMouse}
                      onLeaveMouse={this.onLeaveMouse}
                      onHover={onHover}
                      length={index}
                    />
                  ))
                )}
              </NewCardContainer>
            </div>
          </OndemandContainer>
        ) : (
          ""
        )}
      </div>
    );
  }
}

OnDemandDetailsMain.propTypes = {
  history: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  eventResults: PropTypes.array.isRequired,
  loadMoreEvents: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  attendEvent: PropTypes.func.isRequired,
  activeEvents: PropTypes.array.isRequired,
  pastEvents: PropTypes.array.isRequired,
  featuredVideos: PropTypes.array,
  t: PropTypes.func,
  link: PropTypes.string,
  location: PropTypes.object.isRequired,
  webinarCategory: PropTypes.array,
  onEnterMouse: PropTypes.func.isRequired,
  onLeaveMouse: PropTypes.func.isRequired,
  themesHeader: PropTypes.array,
  role: PropTypes.string,
  ondemandCategory: PropTypes.array,
  fetchOnDemandVideosByCatgoryId: PropTypes.func,
  ondemandByIdData: PropTypes.array,
};

const mapStateToProps = (state) => ({
  ondemandCategory: state.events.ondemandCategory,
  ondemandByIdData: state.events.ondemandByIdData,
});

const mapDispatchToProps = (dispatch) => ({
  fetchOnDemandVideosByCatgoryId: (id) =>dispatch(fetchOnDemandVideosByCatgoryId(id)),
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(OnDemandDetailsMain));